import React from "react";
import { withTranslation } from "react-i18next";

import QuestionResultStatus from "../../../QuestionResultStatus";
import LabelBadge from "../../../LabelImages/components/LabelBadge";
import { getImageLabel } from "../../../../util";

const QuestionItem = ({ question, t }) => {
  const imageLabel = getImageLabel(question.images);

  return (
    <div className="checklist-row">
      <div className="checklist-row-main">
        <span className="row-label">{question.title}</span>
        {question.raw && (
          <span className="row-remarks">
            <span className="remarks-title">{t("cc_remarks").message || "Remarks"}:</span>
            <span className="remarks-value"> {question.raw}</span>
          </span>
        )}
      </div>

      <div className="checklist-row-side">
        {imageLabel && (
          <span className="checklist-row-badge-wrap">
            <LabelBadge label={imageLabel} />
          </span>
        )}

        <span className="checklist-row-status">
          <QuestionResultStatus status={question.status} />
        </span>
      </div>
    </div>
  );
};

export default withTranslation()(QuestionItem);
